module.exports = __webpack_public_path__ + "static/media/powered_by_kushki_logo.b9c0ad70.svg";